export abstract class Tool {
  public abstract title: string;

  public abstract icon: string;
}
